const subs = () => {
    return ( 
        <div>
            <h1>előfizetések</h1>
        </div>
     );
}
 
export default subs;